import * as appStateActions from 'actions/appStateActions';
import * as featureFlagActions from 'actions/featureFlagActions';
import dates from 'utils/dates';
import userClassAssignment from 'config/userClassAssignment';
import temporaryFeatures from 'config/temporaryFeatures';
import { hash2Obj, readCookie } from 'utils/utils';
import { connect } from 'react-redux';

const mapFeatureFlagsStateToProps = state => ({
  featureFlags: state.featureFlags,
});

export function withFeatureFlags(component) {
  return connect(mapFeatureFlagsStateToProps)(component);
}

const defaultProps = {
  assetRoot: '',
  version: '',
  environment: '',
  theme: 'loveholidays',
  isHeaderHidden: false,
  isFooterHidden: false,
  isPhoneEnabled: false,
  landlinePhone: '',
  afterSalesPhone: '',
  braintreeToken: '',
  serverLeg: '',
  backbonePandaChangeTab: () => ({}),
  reactFetchCalendarOffers: () => ({}),
  bannerHome: '',
  bannerSearchResults: '',
  bannerHotelDetails: '',
  bannerHomeUrl: '',
  state: '',
  calDate: 0,
  manageMyBooking: {},
  manageAddPassengerInfo: {},
  cms: {},
  token: '',
  landlinePhoneMinBasketValueDP: 0,
  landlinePhoneMinBasketValueHO: 0,
  landlinePhoneOnBook: true,
  landlinePhoneOnPanda: true,
  landlinePhoneOnFAQ: true,
  landlinePhoneOnMobile: true,
  footerDestinationLinks: [],
  footerAirportLinks: [],
  footerHotelLinks: [],
  footerHolidayLinks: [],
  loggedInSupplier: [],
  footerTerms: {},
  changePasswordLink: '',
};

function initialState() {
  return {
    store: null,
    user: {},
    userClass: [],
    featureEntities: {},
    featureQueriedItems: {},
    featureCookieItems: {
      BookDisplayPerNightPricing: 'lvh_per_night_pricing',
    },
  };
}

let state = initialState();

function setUserClass(featureUserClass) {
  if (featureUserClass && state.userClass.indexOf(featureUserClass.toUpperCase()) === -1) {
    state.userClass.push(featureUserClass.toUpperCase());
  }
}

function deleteUserClass(featureUserClass) {
  const index = state.userClass.indexOf(featureUserClass.toUpperCase());

  state.userClass.splice(index, 1);
}

function setFeatureFlag(featureKey) {
  setUserClass(userClassAssignment[featureKey]);
  state.featureEntities[featureKey] = true;

  if (state.store) {
    state.store.dispatch(featureFlagActions.setFeatureFlag(featureKey));
  }
}

function updateUser(userData) {
  const keys = Object.keys(userData);

  keys.map((key) => {
    state.user[key] = userData[key];
  });
}

/* eslint-disable no-console */
export function validateHotelQueryProps(query) {
  const requiredNumberParams = ['masterId', 'duration', 'adults'];
  const optionalNumberParams = ['deptDate'];
  const optionalArrayParams = ['childAges', 'loggedInSupplier'];
  let isValid = true;

  requiredNumberParams.forEach((key) => {
    if (!query[key]) {
      console.error(`LHX hotelOnlyQuery missing required property: ${key}`);
      isValid = false;
    } else if (typeof query[key] !== 'number') {
      console.error(`LHX hotelOnlyQuery property must be number: ${key}`);
      isValid = false;
    }
  });

  optionalNumberParams.forEach((key) => {
    if (query[key] && typeof query[key] !== 'number') {
      console.error(`LHX hotelOnlyQuery property must be number: ${key}`);
      isValid = false;
    }
  });

  optionalArrayParams.forEach((key) => {
    if (query[key] && !Array.isArray(query[key])) {
      console.error(`LHX hotelOnlyQuery property must be Array: ${key}`);
      isValid = false;
    }
  });

  return isValid;
}
/* eslint-enable no-console */

export function setFeaturesFromCookies() {
  const cookies = state.featureCookieItems;
  Object.keys(cookies)
    .filter(flag => readCookie(cookies[flag]))
    .forEach(setFeatureFlag);
}

export function setFeaturesFromSearchQuery(search) {
  const searchObj = hash2Obj(search);
  const featureKeyItems = searchObj.lhx && searchObj.lhx.split(',');

  if (featureKeyItems) {
    featureKeyItems.map(setFeatureFlag);
  }
}

export function setUserClassFromSearchQuery(search) {
  const searchObj = hash2Obj(search);
  const userClassKeyItems = searchObj.uc && searchObj.uc.split('');

  if (userClassKeyItems) {
    userClassKeyItems.map(setUserClass);
  }
}

/* eslint-disable no-console */
export function setFeaturesFromTemporaryFeatures(featuresObj) {
  const featureKeys = Object.keys(featuresObj);

  featureKeys.map((key) => {
    setFeatureFlag(key);

    /* istanbul ignore if */
    if (__DEBUG__) {
      const maxDays = 90;
      const tempFeatureDate = dates.isoStringToDate(featuresObj[key]);
      const tempFeatureExpireDate = tempFeatureDate.setDate(tempFeatureDate.getDate() + maxDays);

      if (tempFeatureExpireDate > Date.now()) {
        console.warn(`LHX temporary feature set for over ${maxDays} days: '${key}' set on ${dates.format(tempFeatureDate, 'DD MMM YYYY')}`);
      }
    }
  });
}
/* eslint-enable no-console */

class LoveholidaysExternalApi {
  constructor() {
    /* istanbul ignore next */
    const initialConfig = window.LHX || [];

    this.setDefaultProps();
    initialConfig.forEach(this.push, this);
    setFeaturesFromCookies();

    if (window && window.location && window.location.search) {
      setFeaturesFromSearchQuery(window.location.search);
      setUserClassFromSearchQuery(window.location.search);
    }
    setFeaturesFromTemporaryFeatures(temporaryFeatures);
  }

  connectToStore(newStore) {
    state.store = newStore;

    this.enabledFeatures.forEach((featureFlag) => {
      state.store.dispatch(featureFlagActions.setFeatureFlag(featureFlag));
    });

    Object.keys(defaultProps).forEach((key) => {
      state.store.dispatch(appStateActions.setLHXProperty(key, this[key]));
    });
  }

  setDefaultProps() {
    Object.keys(defaultProps).forEach((key) => {
      this.setProperty(key, defaultProps[key]);
    });
  }

  setProperty(key, value) {
    this[key] = value;
    if (state.store) {
      state.store.dispatch(appStateActions.setLHXProperty(key, value));
    }
  }

  get user() {
    return state.user;
  }

  get userClass() {
    return state.userClass.sort().join('');
  }

  get enabledFeatures() {
    return Object.keys(state.featureEntities);
  }

  get queriedFeatures() {
    return Object.keys(state.featureQueriedItems);
  }

  isEnabled(featureKey) {
    state.featureQueriedItems[featureKey] = true;

    return !!state.featureEntities[featureKey];
  }

  handleConfigObj(configObj) {
    let isMatched = false;
    const allowedMethods = {
      user: updateUser,
      dangerouslySetUserClass: setUserClass,
      dangerouslyDeleteUserClass: deleteUserClass,
    };
    const configObjKeys = Object.keys(configObj) || [];

    configObjKeys.forEach((key) => {
      if (typeof defaultProps[key] !== 'undefined' && typeof defaultProps[key] === typeof configObj[key]) {
        this.setProperty(key, configObj[key]);
        isMatched = true;
      } else if (allowedMethods[key]) {
        allowedMethods[key](configObj[key]);
        isMatched = true;
      }
    });

    return isMatched;
  }

  push() {
    let isMatched = false;

    for (const featureFlagOrConfigObj of arguments) {
      if (typeof featureFlagOrConfigObj === 'string') {
        setFeatureFlag(featureFlagOrConfigObj);
        isMatched = true;
      } else {
        isMatched = this.handleConfigObj(featureFlagOrConfigObj);
      }
    }

    return isMatched;
  }
}

const LHX = new LoveholidaysExternalApi();

export function resetLHX() {
  state = initialState();

  LHX.setDefaultProps();
}

Object.defineProperty(window, 'LHX', {
  value: LHX,
});

export default LHX;



/** WEBPACK FOOTER **
 ** ./src/utils/LHX.js
 **/